module.exports = __webpack_public_path__ + "src/img/timer/aniPage/0612de13e0ddb636b56be23f18ea1282.png";